// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.btn {
  /* Override Bootstrap assigning an 'active' colour (slightly different from what is required) to the button */
  --bs-btn-active-bg: ;
  --bs-btn-active-border-color: ;
  font-size: 0.85rem;
}

.btn-group-height {
  height: 44px;
}`, "",{"version":3,"sources":["webpack://./libs/msslib/src/lib/components/formly/fields/radio-button/radio-button.component.scss"],"names":[],"mappings":"AAEA;EACE,6GAAA;EACA,oBAAA;EACA,8BAAA;EAEA,kBAAA;AAFF;;AAKA;EACE,YAAA;AAFF","sourcesContent":["@use 'mssvariables' as *;\n\n.btn {\n  /* Override Bootstrap assigning an 'active' colour (slightly different from what is required) to the button */\n  --bs-btn-active-bg: #{theme-color('colour-blue-600')};\n  --bs-btn-active-border-color: #{theme-color('colour-blue-600')};\n\n  font-size: 0.85rem;\n}\n\n.btn-group-height {\n  height: 44px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
